import { render, staticRenderFns } from "./LogosCrimes.vue?vue&type=template&id=7592185e&"
import script from "./LogosCrimes.vue?vue&type=script&lang=js&"
export * from "./LogosCrimes.vue?vue&type=script&lang=js&"
import style0 from "./LogosCrimes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports